/**
 * @generated SignedSource<<0a26c00cdac2e19bfea142cccf743814>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type colorPaletteSettings_palettesWithColorsQuery$variables = {
  after?: string | null;
  first?: number | null;
  numberOfColorsToShow?: number | null;
  orderBy?: string | null;
  paletteTypeID?: number | null;
  search?: string | null;
};
export type colorPaletteSettings_palettesWithColorsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"colorPaletteSettings_palettesWithColors">;
};
export type colorPaletteSettings_palettesWithColorsQuery = {
  response: colorPaletteSettings_palettesWithColorsQuery$data;
  variables: colorPaletteSettings_palettesWithColorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numberOfColorsToShow"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paletteTypeID"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "numberOfColorsToShow",
    "variableName": "numberOfColorsToShow"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "paletteTypeID",
    "variableName": "paletteTypeID"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "colorPaletteSettings_palettesWithColorsQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "kind": "FragmentSpread",
        "name": "colorPaletteSettings_palettesWithColors"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "colorPaletteSettings_palettesWithColorsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "PalettesWithColorsConnection",
        "kind": "LinkedField",
        "name": "palettesWithColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PalettesWithColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Palette",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useConversionTable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paletteTypeID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isZakekeDefault",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaletteColor",
                    "kind": "LinkedField",
                    "name": "colors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorID",
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rgbHexCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cmykHexCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "spotColorName",
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "associationWithPrintTypes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "filters": [
          "search",
          "numberOfColorsToShow",
          "paletteTypeID",
          "orderBy"
        ],
        "handle": "connection",
        "key": "palettesWithColors_palettesWithColors",
        "kind": "LinkedHandle",
        "name": "palettesWithColors"
      }
    ]
  },
  "params": {
    "cacheID": "534be5f4a4283b94d13117d76d87dc8f",
    "id": null,
    "metadata": {},
    "name": "colorPaletteSettings_palettesWithColorsQuery",
    "operationKind": "query",
    "text": "query colorPaletteSettings_palettesWithColorsQuery(\n  $first: Int\n  $after: String\n  $search: String\n  $numberOfColorsToShow: Int\n  $paletteTypeID: Int\n  $orderBy: String\n) {\n  ...colorPaletteSettings_palettesWithColors_UJ1NN\n}\n\nfragment colorPaletteSettings_palettesWithColors_UJ1NN on Query {\n  palettesWithColors(first: $first, after: $after, search: $search, numberOfColorsToShow: $numberOfColorsToShow, paletteTypeID: $paletteTypeID, orderBy: $orderBy) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        name\n        useConversionTable\n        paletteTypeID\n        isZakekeDefault\n        colors {\n          colorID\n          name\n          rgbHexCode\n          cmykHexCode\n          spotColorName\n          id\n        }\n        associationWithPrintTypes\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e080110c4bc75f5871f337e4a29c63f";

export default node;
